import { render, staticRenderFns } from "./TabTemplates.vue?vue&type=template&id=9c2de55c&scoped=true&"
import script from "./TabTemplates.vue?vue&type=script&lang=js&"
export * from "./TabTemplates.vue?vue&type=script&lang=js&"
import style0 from "./TabTemplates.vue?vue&type=style&index=0&id=9c2de55c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2de55c",
  null
  
)

export default component.exports